export default __webpack_public_path__ + "static/media/arrival.36edec4e.svg";